import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElBanner, ElContent, elGapBanner, elGapTitle, ElDetails, ElBannerImageInfinite, ElBannerImageCircle, ElContentParent } from "./normal-text.css";
import { Container } from "../../layout";
import { elFlexJustifyStart } from "../../../@css-style";
import { cx } from "@linaria/core";
import { ElHeadLine } from "../head-title";

interface INormalTextProps extends HTMLAttributes<HTMLElement> {
  texts: {
    title: string;
    desc: string;
  }[];
  title: string;
}

export const NormalText: FC<INormalTextProps> = ({ children, texts, title, ...props }) => {
  const getLength = () => {
    const size = 100 / texts.length;
    return `${size}%`;
  };
  return (
    <ElBanner {...props}>
      <ElBannerImageInfinite src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/cicrcle.png' />
      <ElBannerImageCircle src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/cicrcle.png' />
      <Container className={elGapBanner}>
        <ElContent className={cx(elFlexJustifyStart, elGapTitle)}>
          <ElHeadLine style={{ "--hashTag": `"#EXPLORE PROGRAM"` }}>{title}</ElHeadLine>
        </ElContent>
        <ElContentParent>
          {texts.map((text, i) => (
            <ElContent key={i} className={cx(elFlexJustifyStart, elGapTitle)} style={{ width: getLength() }}>
              <ElDetails
                dangerouslySetInnerHTML={{
                  __html: text.title,
                }}
              ></ElDetails>
              <ElDetails
                dangerouslySetInnerHTML={{
                  __html: text.desc,
                }}
              ></ElDetails>
            </ElContent>
          ))}
        </ElContentParent>
      </Container>
    </ElBanner>
  );
};
